import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import React, { useEffect, useState } from "react";
import ReactWebChat from "botframework-webchat";
import { DirectLine } from "botframework-directlinejs";
import { loginRequest } from "../authConfig";
import { InteractionStatus } from "@azure/msal-browser";
import { callMw } from "../utils/mwDlTokenRequest";
import zhivaLogo from "../assets/new_zhiva.png";

export function Home() {

  const { instance, inProgress } = useMsal();
  const [token, setToken] = useState(null);
  const [initialized, setInitialized] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const styleOptions = {  
    backgroundColor: 'transparent',
    bubbleFromUserBackground: '#003399',
    bubbleFromUserBorderRadius: 10,
    bubbleBorderRadius: 10,
    bubbleFromUserTextColor: 'white',
    sendBoxHeight: '60px',
    autoScrollSnapOnActivity: true,
    autoScrollSnapOnPage: true,
    groupTimestamp: false,
    hideUploadButton: true
   };
  
  


  useEffect(() => {
    if (instance.getAllAccounts().length == 0){
      if (inProgress === InteractionStatus.None) {
        instance.loginRedirect(loginRequest).then(() => {
          if(!initialized){
            callMw().then(response => setToken(response)).catch(error => console.log(error));
            setInitialized(true)
          }
          
        })
    }
  }
  else{
    if(!initialized){
      callMw().then(response => setToken(response)).catch(error => console.log(error));
      setInitialized(true)
    }
  }

  })
  //Add your DL token
  if (token){
    return (
      <>
          <AuthenticatedTemplate>
          <div
            id="zhiva-container"
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              flexWrap: 'wrap',
              height: "100%", 
              width: "100%",
              backgroundColor: "rgb(237, 238, 240)",
            }}
          >
            {isMobile ? (
              // Mobile layout
              <>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "1rem 0",
                    backgroundColor: "rgb(237, 238, 240)",
                  }}
                  id="zhivaLogoMobile"
                >
                  <img
                    src={zhivaLogo}
                    alt="zhiva logo"
                    style={{ 
                      width: "150px",
                      height: "auto"
                    }}
                  />
                </div>
                
                <div id="zhiva-bot" style={{ 
                  width: "100%", 
                  height: "calc(100% - 120px)",
                  padding: "0 15px",
                  boxSizing: "border-box"
                }}>
                  <div style={{ 
                    height: "97%",
                    margin: "0 auto",
                    maxWidth: "100%"
                  }}>
                    {token !== "" ? (
                      <>
                        <ReactWebChat
                          styleOptions={{
                            ...styleOptions,
                            sendBoxHeight: '50px',
                            rootWidth: '100%',
                            rootHeight: '100%'
                          }}
                          directLine={new DirectLine({ token: token })}
                        />
                        <div style={{ textAlign: 'center', marginTop: '10px' }}>
                          <a href="mailto:zhiva@zurich.com?subject=Issue with ZhiVA" style={{ color: '#003399', textDecoration: 'underline', cursor: 'pointer', fontSize: '11px' }}>
                            Can't find what you're looking for? Contact us!
                          </a>
                        </div>
                      </>
                    ) : (
                      <div className="loader-container">
                        <div className="loader" />
                      </div>
                    )}
                  </div>
                </div>
              </>
            ) : (
              // Desktop layout
              <div style={{ display: "flex", height: "100%", width: "100%" }}>
                <div
                  style={{
                    width: "300px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                  }}
                  id="zhivaLogo"
                >
                  <div style={{ padding: "2rem" }}>
                    <img
                      src={zhivaLogo}
                      alt="zhiva logo"
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
                
                <div id="zhiva-bot" style={{ width: "calc(100% - 600px)" }}>
                  <div style={{ height: "97%" }}>
                    {token !== "" ? (
                      <>
                        <ReactWebChat
                          styleOptions={styleOptions}
                          directLine={new DirectLine({ token: token })}
                        />
                        <div style={{ textAlign: 'center', marginTop: '10px' }}>
                          <a href="mailto:zhiva@zurich.com?subject=Issue with ZhiVA" style={{ color: '#003399', textDecoration: 'underline', cursor: 'pointer', fontSize: '12px' }}>
                            Can't find what you're looking for? Contact us!
                          </a>
                        </div>
                      </>
                    ) : (
                      <div className="loader-container">
                        <div className="loader" />
                      </div>
                    )}
                  </div>
                </div>
                
                <div style={{ width: "300px" }} id="itLogo">
                  <div style={{ padding: "2rem" }}>
                   
                  </div>
                </div> 
              </div>
            )}
          </div>
        
          </AuthenticatedTemplate>

          <UnauthenticatedTemplate>
            
          </UnauthenticatedTemplate>
      </>
  );
  }
  else{
    return (
      <>
          <AuthenticatedTemplate>
              <div style={{
                height: "100%", 
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
              }}> 
                <div className="loader-container">
                  <div className="loader" />
                </div>
              </div>
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>

          </UnauthenticatedTemplate>
      </>
    );
  }
  
}
